import { render, staticRenderFns } from "./HistoryEdit.vue?vue&type=template&id=2fc3ecb3&scoped=true&"
import script from "./HistoryEdit.vue?vue&type=script&lang=js&"
export * from "./HistoryEdit.vue?vue&type=script&lang=js&"
import style0 from "./HistoryEdit.vue?vue&type=style&index=0&id=2fc3ecb3&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc3ecb3",
  null
  
)

export default component.exports